export class InvalidationManager {
    constructor() {
        this.callbacks = [];
    }
    invalidate() {
        this.callbacks.forEach((callback) => callback());
    }
    onInvalidate(callback) {
        this.callbacks.push(callback);
    }
}
